module.exports = __webpack_public_path__ + "static/media/font-icon-active.9e17a5d1.svg";